<form
  nz-form
  [formGroup]="balanceForm"
  (ngSubmit)="addBalance()"
  style="margin-top: 15px"
  >
  <div nz-row [nzGutter]="[15, 15]">
    <div nz-col class="gutter-row" [nzSpan]="12">
      <beautyapp-datepicker
        [disabled]="!roles.includes('Admin') && !roles.includes('Manager')"
        label="{{ 'users.transactionDate' | translate }}"
        required
        formControlName="transactionDate"
        [maxDate]="maxDate"
      ></beautyapp-datepicker>
    </div>
    <div nz-col class="gutter-row" [nzSpan]="12">
      <beautyapp-select
        label="{{ 'users.operationType' | translate }}"
        required
        [data]="[
          {
            value: 'BALANCEIN',
            label: 'users.topUpBalance' | translate
          },
          {
            value: 'BALANCERETURN',
            label: 'users.returnBalance' | translate
          }
        ]"
      displayMember="label"
      valueMember="value"
      formControlName="operationType"
      >
    </beautyapp-select>
  </div>
  <div nz-col class="gutter-row" [nzSpan]="12">
    <beautyapp-input
      formControlName="minutes"
      prefixIcon="clock-circle"
      type="float"
      [label]="'users.numberMinutes' | translate"
    ></beautyapp-input>
  </div>
  <!--
    beaut-517: the same choice the money tab asks for. A minute balance can be
    granted without money just as a money balance can, and until it was asked
    the record could not tell the two apart.
  -->
  <div nz-col class="gutter-row" [nzSpan]="12">
    <beautyapp-select
      label="{{ 'users.moneyMode' | translate }}"
      required
      [data]="[
        { value: false, label: 'users.withoutMoney' | translate },
        { value: true, label: 'users.withMoney' | translate }
      ]"
      displayMember="label"
      valueMember="value"
      formControlName="withMoney"
    >
    </beautyapp-select>
  </div>

  @if (balanceForm.get('withMoney')?.value) {
  <div nz-col class="gutter-row" [nzSpan]="12">
    <beautyapp-select
      label="{{ 'users.typePayment' | translate }}"
      required
        [data]="[
          {
            value: 1,
            label: 'PAYMENTTYPE.1' | translate
          },
          {
            value: 2,
            label: 'PAYMENTTYPE.2' | translate
          },
          {
            value: 3,
            label: 'PAYMENTTYPE.3' | translate
          },
          {
            value: 5,
            label: 'PAYMENTTYPE.5' | translate
          },
          {
            value: 6,
            label: 'PAYMENTTYPE.6' | translate
          },
          {
            value: 8,
            label: 'PAYMENTTYPE.8' | translate
          }
        ]"
    displayMember="label"
    valueMember="value"
    formControlName="paymentType"
    >
  </beautyapp-select>
</div>
}

@if (
  balanceForm.get('paymentType')?.value === 2 ||
  balanceForm.get('paymentType')?.value === 3 ||
  balanceForm.get('paymentType')?.value === 8
) {
  <div nz-col class="gutter-row" [nzSpan]="12">
    <beautyapp-select
      label="{{ 'statistic.operation.column.bankName' | translate }}"
      [data]="banks"
      displayMember="label"
      valueMember="value"
      formControlName="bank"
    ></beautyapp-select>
  </div>
}

@if (balanceForm.get('paymentType')?.value === 1) {
  <div
    nz-col
    class="gutter-row"
    [nzSpan]="12"
    >
    <beautyapp-input
      formControlName="cash"
      prefix="₾"
      type="number"
      [label]="'PAYMENTTYPE.1' | translate"
      required
    ></beautyapp-input>
  </div>
}
@if (balanceForm.get('paymentType')?.value === 2) {
  <div nz-col class="gutter-row" [nzSpan]="12">
    <beautyapp-input
      formControlName="card"
      prefix="₾"
      type="number"
      [label]="'PAYMENTTYPE.2' | translate"
      required
    ></beautyapp-input>
  </div>
}
@if (balanceForm.get('paymentType')?.value === 3) {
  <div nz-col class="gutter-row" [nzSpan]="12">
    <beautyapp-input
      formControlName="cash"
      prefix="₾"
      type="number"
      [label]="'PAYMENTTYPE.1' | translate"
      required
    ></beautyapp-input>
  </div>
  <div nz-col class="gutter-row" [nzSpan]="12">
    <beautyapp-input
      formControlName="card"
      prefix="₾"
      type="number"
      [label]="'PAYMENTTYPE.2' | translate"
      required
    ></beautyapp-input>
  </div>
}
@if (balanceForm.get('paymentType')?.value === 8) {
  <beautyapp-input
    label="{{ 'calendar.form.bankTransfer' | translate }}"
    placeholder="{{ 'calendar.form.bankTransfer' | translate }}"
    type="number"
    prefixIcon="tags"
    formControlName="bankTransfer"
  ></beautyapp-input>
}
@if (balanceForm.get('paymentType')?.value === 5) {
  <beautyapp-input
    label="{{ 'calendar.form.balance' | translate }}"
    placeholder="{{ 'calendar.form.balance' | translate }}"
    type="number"
    prefixIcon="tags"
    formControlName="balance"
    required
    [max]="user.balance || 0"
    [min]="1"
      [errors]="{
        min: 'users.minBalance' | translate,
        max: 'users.maxBalance' | translate
      }"
  ></beautyapp-input>
}
@if (balanceForm.get('paymentType')?.value === 6) {
  <div nz-col class="gutter-row" [nzSpan]="12">
    <beautyapp-input
      formControlName="barter"
      prefix="₾"
      type="number"
      [label]="'PAYMENTTYPE.6' | translate"
      [required]="true"
    ></beautyapp-input>
  </div>
}
<div nz-col class="gutter-row" [nzSpan]="24">
  <beautyapp-textarea
    formControlName="comment"
    [label]="'users.comment' | translate"
    placeholder="{{ 'users.comment' | translate }}"
  ></beautyapp-textarea>
</div>
<div nz-col class="gutter-row" [nzSpan]="24">
  <button nz-button nzType="primary" [nzLoading]="addBalanceLoader">
    {{ 'buttons.pay' | translate }}
  </button>
</div>
</div>
</form>
